/** Soft-deletes branch detail tabs so they can be restored from the Trash screen. */

export const TRASHED_TABS_STORAGE_KEY = "tecGymTrashedBranchTabs";
export const TRASHED_TABS_CHANGED_EVENT = "tecGymTrashedTabsChanged";

function notifyTrashedTabsChanged() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event(TRASHED_TABS_CHANGED_EVENT));
}

export function getTrashedTabs() {
  try {
    const raw = localStorage.getItem(TRASHED_TABS_STORAGE_KEY);
    if (!raw) return [];
    const list = JSON.parse(raw);
    if (!Array.isArray(list)) return [];
    return list.filter(
      (item) => item && typeof item.id === "string" && typeof item.label === "string"
    );
  } catch {
    return [];
  }
}

export function getTrashedTabIds() {
  return new Set(getTrashedTabs().map((tab) => tab.id));
}

function saveTrashedTabs(tabs) {
  try {
    localStorage.setItem(TRASHED_TABS_STORAGE_KEY, JSON.stringify(tabs));
    notifyTrashedTabsChanged();
  } catch {
    /* ignore quota / private mode */
  }
}

export function moveTabToTrash(tab, meta = {}) {
  if (!tab?.id) return getTrashedTabs();

  const existing = getTrashedTabs().filter((item) => item.id !== tab.id);
  const next = [
    {
      id: tab.id,
      label: tab.label || tab.id,
      branchId: meta.branchId || "",
      branchName: meta.branchName || "",
      trashedAt: new Date().toISOString()
    },
    ...existing
  ];
  saveTrashedTabs(next);
  return next;
}

export function restoreTabFromTrash(tabId) {
  const next = getTrashedTabs().filter((item) => item.id !== tabId);
  saveTrashedTabs(next);
  return next;
}

export function permanentlyDeleteTabFromTrash(tabId) {
  return restoreTabFromTrash(tabId);
}

export function clearAllTrashedTabs() {
  saveTrashedTabs([]);
}
